export default function VideoSection() {
  return (
    <section className="bg-gray-50 py-12 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center gap-10">

        {/* Texto izquierda */}
        <div className="w-full md:w-1/3 flex-shrink-0">
          <p className="text-gray-400 uppercase tracking-[0.3em] text-xs mb-3">Conoce Larghetto</p>
          <h2 className="text-3xl md:text-4xl font-black text-black leading-tight mb-4">
            Formación musical con experiencia real
          </h2>
          <p className="text-gray-500 text-sm leading-relaxed mb-6">
            Aprender música no solo es adquirir conocimiento… es vivirla, compartirla y llevarla al escenario.
          </p>
          <p className="text-gray-700 text-sm font-semibold">
            Tu camino en la música empieza hoy.{' '}
            <a
              href="https://wa.me/+525521048568"
              target="_blank"
              rel="noreferrer"
              className="hover:opacity-70 transition-opacity bg-clip-text text-transparent"
              style={{
                backgroundImage: 'linear-gradient(135deg, #FFE033, #FFB800)',
                borderBottom: '1px solid #FFB800',
              }}
            >
              Contáctanos
            </a>
          </p>
        </div>

        {/* Video derecha */}
        <div className="w-full md:w-2/3 flex-shrink-0">
          <div className="relative" style={{ aspectRatio: '16/9', borderRadius: '1.5rem', clipPath: 'inset(0 round 1.5rem)', overflow: 'hidden' }}>
            <iframe
              className="absolute inset-0 w-full h-full"
              style={{ borderRadius: '1.5rem' }}
              src="https://player.vimeo.com/video/1176746636?badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0&controls=0&autoplay=1&muted=1&loop=1"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              loading="lazy"
              title="LARGHETTO 2025"
            />
          </div>
        </div>

      </div>
    </section>
  );
}
